import { Controller } from 'stimulus'; 
export default class extends Controller {

  static targets = [
    "companyTypeSelect",
    "defaultShipperDiv",
    "forwardsToCustomerDiv",
    ];

  connect() {
    this.handleCompanyTypeChange(null);
  }
  
  handleCompanyTypeChange(event) {

    const type = this.companyTypeSelectTarget.value

    var shipperShow = true;
    var forwardShow = true;

    if (type == "CSI"){
      shipperShow = false;
      forwardShow = false;
    }
    else if (type == "Customer")
      forwardShow = false;

    this.defaultShipperDivTarget.hidden = !shipperShow;
    this.forwardsToCustomerDivTarget.hidden = !forwardShow;

  }

}

